/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollNavCurrent.js
 *
 * 追従サイドメニューの現在地ハイライト
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページURL取得
 */
var getPathName = location.pathname;
var pageName = /(department)/g;

/**
 * Settings - var
 */
var elemTop = [];

/**
 * Settings - setScrollPoint
 */
const setScrollPoint = () => {
  var anchor = document.querySelectorAll(".anchor");
  for (let i = 0; i < anchor.length; i++) {
    rect = anchor[i].getBoundingClientRect();
    elemTop[i] = rect.top + window.pageYOffset;
  }
};

/**
 * Settings - setScrollNavCurrent
 */
const setScrollNavCurrent = () => {
  var scroll = window.pageYOffset;
  var NavElem = document.querySelectorAll(".sidebar li a");
  for (let i = 0; i < NavElem.length; i++) {
    NavElem[i].classList.remove("is-current");
    NavElem[i] = NavElem[i];
  }
  if (scroll >= 0 && scroll <= elemTop[1]) {
    NavElem[0].classList.add("is-current");
  } else if (scroll >= elemTop[1] && scroll < elemTop[2]) {
    NavElem[1].classList.add("is-current");
  } else if (scroll >= elemTop[2] && scroll < elemTop[3]) {
    NavElem[2].classList.add("is-current");
  } else if (scroll >= elemTop[3] && scroll < elemTop[4]) {
    NavElem[3].classList.add("is-current");
  } else if (scroll >= elemTop[4] && scroll < elemTop[5]) {
    NavElem[4].classList.add("is-current");
  } else if (scroll >= elemTop[5] && scroll < elemTop[6]) {
    NavElem[5].classList.add("is-current");
  } else {
    NavElem[6].classList.add("is-current");
  }
};

/**
 * 実行判断
 */
if (getPathName.match(pageName)) {
  window.addEventListener("DOMContentLoaded", () => {
    setScrollPoint();
    setScrollNavCurrent();
  });
  window.addEventListener("scroll", () => {
    setScrollPoint();
    setScrollNavCurrent();
  });
  window.addEventListener("resize", setScrollNavCurrent);
}
